<template>
    <el-dropdown
        @command="action"
        class="pt-1"
        trigger="click"
        placement="bottom-end"
    >
        <i
            style="color: #757575; font-size: 1.3rem"
            class="ri-equalizer-line pl-2 pr-2"
        ></i>
        <el-dropdown-menu class="no-select" slot="dropdown">

            <!-- Reset machine -->
            <el-dropdown-item 
                :disabled="element.isNotSupport"
                :command="$action.OPEN_POPUP_RESET_MACHINE"
                v-if="!element.isDemo && element.canReset"
            >
                <a style="text-decoration: none">
                    <i
                        style="margin-right: 0.95rem"
                        class="el-icon-refresh-right"
                    ></i>
                    <span class="font-size-9">{{ $t('machineAction.reset') }}</span>
                </a>
            </el-dropdown-item>

            <!-- Disconnect internet machine -->
            <!-- <el-dropdown-item v-if="!element.isDemo"
                :disabled="element.isNotSupport"
                :command="$action.OPEN_POPUP_ACTIVATE_SOFTWARE_LICENSE"
            >
                <a style="text-decoration: none">
                    <i style="margin-right: 0.95rem" class="ri-certificate-2-line"></i>
                    <span class="font-size-9">{{ $t('machineAction.softwareLicense') }}</span>
                </a>
            </el-dropdown-item> -->

            <!-- Fixed rental create -->
            <el-dropdown-item
                :disabled="element.isNotSupport && element.status == 2"
                :divided="element.canFixedRental && element.canReset"
                v-if="
                    !element.isDemo &&
                    element.packageId !== '28' &&
                    element.status == 2 &&
                    element.canFixedRental
                "
                :command="$action.OPEN_POPUP_FIXED_RENTAL_CREATE"
            >
                <a style="text-decoration: none">
                    <i style="margin-right: 0.95rem" class="el-icon-plus"></i>
                    <span class="font-size-9">{{ $t('bootMachine.rentalPlan') }}</span>
                </a>
            </el-dropdown-item>

            <!-- Renewal fixed rental -->
            <el-dropdown-item
                :disabled="element.isNotSupport"
                :divided="element.canRenewalFixedRental"
                v-if="
                    !element.isDemo &&
                    element.canRenewalFixedRental &&
                    element.showRenewalFixedRental
                "
                :command="$action.OPEN_POPUP_FIXED_RENTAL_RENEWAL_MACHINE"
            >
                <a style="text-decoration: none">
                    <i style="margin-right: 0.95rem" class="el-icon-time"></i>
                    <span class="font-size-9">{{ $t('machineAction.renewal') }}</span>
                </a>
            </el-dropdown-item>

            <!-- Open port -->
            <el-dropdown-item
                :disabled="element.isNotSupport"
                v-if="!element.isDemo && element.canOpenPort"
                :command="$action.OPEN_POPUP_EXTRA_SERVICE_OPEN_PORT"
            >
                <a style="text-decoration: none">
                    <i style="margin-right: 0.95rem" class="el-icon-link"></i>
                    <span class="font-size-9">{{ $t('machineAction.openPort') }}</span>
                </a>
            </el-dropdown-item>

            <!-- Deactivate fixed rental -->
            <el-dropdown-item
                :disabled="element.isNotSupport"
                v-if="!element.isDemo && element.canDeactivateFixedRental"
                :command="$action.OPEN_POPUP_FIXED_RENTAL_DEACTIVATE"
            >
                <a style="text-decoration: none">
                    <i style="margin-right: 0.95rem" class="el-icon-close"></i>
                    <span class="font-size-9">{{ $t('machineAction.deactivate') }}</span>
                </a>
            </el-dropdown-item>

            <!-- Clone image -->
            <el-dropdown-item v-if="!element.isDemo"
                :command="$action.OPEN_POPUP_CLONE_IMAGE"
                :disabled="
                    (element.isNotSupport ||
                    !(
                        element.canClone &&
                        (element.status === 3 || element.status === 6) &&
                        !(element.isSnsCreating || element.isSnsRestoring)
                    ))
                "
            >
                <a style="text-decoration: none">
                    <i
                        style="margin-right: 0.95rem"
                        class="el-icon-copy-document"
                    ></i>
                    <span class="font-size-9">{{ $t('machineAction.clone') }}</span>
                </a>
            </el-dropdown-item>

            <!-- Change service package -->
            <el-dropdown-item
                v-if="!element.isDemo && element.canChangeServicePackage"
                :command="$action.OPEN_POPUP_CHANGE_SERVICE_PACKAGE"
            >
                <a style="text-decoration: none">
                    <i
                        style="margin-right: 0.95rem"
                        class="ri-arrow-left-right-line"
                    ></i>
                    <span class="font-size-9">{{ $t('machineAction.changePackage') }}</span>
                </a>
            </el-dropdown-item>

            <!-- Settings machine -->
            <el-dropdown-item v-if="!element.isDemo"
                :command="$action.OPEN_POPUP_SETTINGS_MACHINE">
                <a style="text-decoration: none">
                    <i
                        style="margin-right: 0.95rem"
                        class="el-icon-setting"
                    ></i>
                    <span class="font-size-9">{{ $t('toolbar.settings') }}</span>
                </a>
            </el-dropdown-item>

            <!-- Remove image -->
            <el-dropdown-item
                v-if="element.canRemove"
                :command="$action.OPEN_POPUP_REMOVE_IMAGE"
                :divided="!element.isDemo"
            >
                <a style="text-decoration: none; min-width: 150px;" class="d-inline-block text-danger">
                    <i style="margin-right: 0.95rem" class="el-icon-delete"></i>
                    <span class="font-size-9">{{ $t('machineAction.remove') }}</span>
                </a>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
// Event, Dialog
import EventBus from "@/event/EventBus";

// Constant
import { POPUP_ID, POPUP_NAME } from "@/constant/baseConstant";

export default {
    data() {
        return {};
    },

    props: {
        element: {
            type: Object,
            default() {
                return {};
            },
        },
    },

    methods: {
        action(type) {
            switch (type) {
                case this.$action.OPEN_POPUP_EXTRA_SERVICE_OPEN_PORT:
                    EventBus.$emit("processingEventApp", {
                        event: "processOpenPopup",
                        data: {
                            type: POPUP_ID.EXTRA_SERVICE_OPEN_PORT,
                            name: POPUP_NAME.EXTRA_SERVICE_OPEN_PORT,
                            data: this.element,
                        },
                    });
                    break;
                default:
                    this.$emit("processingEvent", {
                        event: "action",
                        data: {
                            type: type,
                            data: this.element,
                        },
                    });
                    break;
            }
        },
    },
};
</script>